<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $t('labels.nav.bank_feed') }}</h3>
    </route-header>
    <div class="row">
      <div class="col">
        <bank-feeds />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankFeed',
  data () {
    return {
    }
  }
}
</script>
